import React from "react";
import ManageScoreContainer from "../../containers/configuration/ManageScore";

const ManageScore = () => {
  return <ManageScoreContainer />;
};

export default ManageScore;
